import React from 'react';
import type { Node } from 'react';
import styled from '@emotion/styled';
import { Badge, Text } from '@vmos2/design-system';
import { useTranslation } from 'react-i18next';

type Props = {
  loyaltyData: {
    rewardsCount: number,
  },
  mode: string,
};

export const RewardCounter = ({ loyaltyData, mode = 'RewardCounter', ...rest }: Props): Node => {
  const { t } = useTranslation();
  const userLoyaltyData = loyaltyData || {};
  const { rewardsCount = 0 } = userLoyaltyData;

  if (!Object.keys(userLoyaltyData).length) {
    return null;
  };

  return (
    <Text dataTest="reward-counter" display="block" level={4} mode={mode} {...rest} strong>
      <Badge align="center" mr={2} type="brand" mode="RewardCounter">
        <RewardsNumber>{rewardsCount}</RewardsNumber>
      </Badge>

      {t(`loyalty:rewardsToClaim`, { count: rewardsCount })}
    </Text>
  );
};

const RewardsNumber = styled.span`
  display: inline-block;
  min-width: 12px;
`;
